
import classNames from "classnames"
import React, { FC, useMemo } from "react"
import { Image } from "antd-mobile"
import { arrow_right, arrow_right_gray_icon, carbon_history, huanbao_history, humanity_history, walfare_participation_1, walfare_participation_2, walfare_participation_3 } from "~src/constants/network"
import { WelfareMoldTyp, WelfareVosType } from "~src/service/welfare/welfare"
import { getLastTimeStr } from "~src/utils/tool"
import styles from "./index.module.less"


interface WelfareColorType {
  backgroundImage: string
  footerImage: string
}
type WelfareKakeColorType = Record<WelfareMoldTyp, WelfareColorType>


interface WelfareParticipantProps {
  type: WelfareMoldTyp
  vos: WelfareVosType
  name: string
  isOnChain: number;
  onClick?: () => void
  goToBlockChain?: (id: string) => void
}

const WelfareParticipant: FC<WelfareParticipantProps> = ({ type, vos, name, isOnChain, onClick, goToBlockChain }) => {
  const { num, participationVOS = [] } = vos

  const welfareImage: WelfareKakeColorType = useMemo(() => ({
    "1": {
      backgroundImage: carbon_history,
      footerImage: walfare_participation_1,
    },
    "2": {
      backgroundImage: huanbao_history,
      footerImage: walfare_participation_2,
    },
    "3": {
      backgroundImage: humanity_history,
      footerImage: walfare_participation_3,

    }
  }), [])
  const { backgroundImage } = useMemo(() => welfareImage[type as WelfareMoldTyp] || { backgroundImage: "" }, [type, welfareImage])
  const { footerImage } = useMemo(() => welfareImage[type as WelfareMoldTyp] || { footerImage: "" }, [type, welfareImage])
  const onMoreParticipant = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <div className={styles.participant}>
      <div className={styles["participant-title"]}>
        <img className={styles["participant-title-bg"]} src={backgroundImage} alt="" />
        <div className={styles["participant-content"]}>
          <div className={styles["participant-content-num"]}>{num}人已参与了捐助</div>
          <div className={styles["participant-content-desc"]}>{name}</div>
        </div>
      </div>
      {
        participationVOS.map((item, index) => {
          return <div key={index} className={styles["participant-vos"]}>
            <div className={styles["participant-vos-info"]}>
              <img className={styles["participant-vos-info-img"]} src={item.headImg} alt="" />
              <div className={styles["participant-vos-info-name"]}>{item.userName}</div>
            </div>
            <div>{item.participateType}</div>
            <div className={styles["participant-vos-date"]} onClick={isOnChain === 1 ? goToBlockChain?.bind(this, item.id) : undefined}>
              {getLastTimeStr(item.date, true)}
              {isOnChain === 1 ? <Image src={arrow_right_gray_icon} className={styles["participant-vos-date-icon"]} /> : null}
            </div>
          </div>
        })
      }
      {isOnChain === 1 ?
        <div className={styles['participant-bottom']}>
          <div className={styles["certification-pack"]} onClick={onMoreParticipant}>
            <span>更多参与记录</span>
            <Image className={styles["certification-pack-arrow"]} src={arrow_right} />
          </div>
          <Image src={footerImage} className={styles['participant-bottom-img']} fit="scale-down" />
        </div>
        : <div className={classNames(styles["participant-title"], styles["participant-first"])}>
          <img className={styles["participant-title-bg"]} src={backgroundImage} alt="" />
          <div className={styles["participant-help"]}>青山绿水有你的一份功劳～</div>
        </div>}

    </div>
  )
}
export default WelfareParticipant
